module.exports = __webpack_public_path__ + "img/user_collection_null_logo_MyMind.90ee9c75.svg";